const postcodes = require("../../common/utils/newham-postcodes.json");

export const GB_SOUTHSTAFFORDSHIRE_DEMO_ZIPCODE = postcodes;

export const GB_SOUTHSTAFFORDSHIRE_ALLOWED_ZIPCODE = [
	"B74",
	"B75",
	"B77",
	"B78",
	"B79",
	"DE1",
	"DE13",
	"DE14",
	"DE15",
	"DE6",
	"ST10",
	"ST11",
	"ST12",
	"ST14",
	"ST15",
	"ST16",
	"ST17",
	"ST18",
	"ST19",
	"ST20",
	"ST21",
	"ST3",
	"ST4",
	"ST5",
	"WS11",
	"WS12",
	"WS13",
	"WS14",
	"WS15",
	"WS3",
	"WS6",
	"WS7",
	"WS8",
	"WS9",
	"WV10",
	"WV10",
	"WV11",
	"WV15",
	"WV3",
	"WV4",
	"WV5",
	"WV6",
	"WV7",
	"WV8",
	"WV9",
];

export const LANCS_ZIPCODE_DEMO = [
	"bb0",
	"bb1",
	"bb10",
	"bb11",
	"bb12",
	"bb18",
	"bb2",
	"bb3",
	"bb4",
	"bb5",
	"bb6",
	"bb7",
	"bb8",
	"bb9",
	"bb94",
	"bd23",
	"bl0",
	"bl6",
	"bl7",
	"bl8",
	"bl9",
	"fy0",
	"fy1",
	"fy2",
	"fy3",
	"fy4",
	"fy5",
	"fy6",
	"fy7",
	"fy8",
	"l31",
	"l33",
	"l37",
	"l39",
	"l40",
	"la1",
	"la10",
	"la11",
	"la12",
	"la13",
	"la14",
	"la15",
	"la16",
	"la17",
	"la18",
	"la19",
	"la2",
	"la20",
	"la21",
	"la22",
	"la23",
	"la3",
	"la4",
	"la5",
	"la6",
	"la7",
	"la8",
	"la9",
	"ol12",
	"ol13",
	"ol14",
	"pr0",
	"pr1",
	"pr11",
	"pr2",
	"pr25",
	"pr26",
	"pr3",
	"pr4",
	"pr5",
	"pr6",
	"pr7",
	"pr8",
	"pr9",
	"wa11",
	"wn5",
	"wn6",
	"wn8",
];
